import { render } from "./DespachadoresIndex.vue?vue&type=template&id=1acd395b"
import script from "./DespachadoresIndex.vue?vue&type=script&lang=js"
export * from "./DespachadoresIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/cruds/DespachadoresIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1acd395b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1acd395b', __exports__)) {
    api.reload('1acd395b', __exports__)
  }
  
  module.hot.accept("./DespachadoresIndex.vue?vue&type=template&id=1acd395b", () => {
    api.rerender('1acd395b', render)
  })

}


export default __exports__